global.bookedby.constants = {
  RECEIVE_NOTIFICATION_TEXT: "Check here if you want to receive text messages regarding wait times, reminders, and updates for your service. Message & data rates may apply.",
  MARKETING_OPT_IN_TEXT: "I would like to receive text notifications for offers, promotional information, and reminders from Sport Clips Promo Alerts. Msg & data rates may apply.",
  MARKETING_OPT_OUT_TEXT: "Text STOP to 21993 to stop receiving Sport Clips Promo Alert messages from Sport Clips Haircuts. Msg & data rates may apply.",
}

module.exports = {};